import { IntroObject } from "../app/shared/introJs/introJs"

AppController.$inject = ["$http", "$auth", "$rootScope", "ngIntroService","$state"];

function AppController($http, auth, rootScope, ngIntroService,state) {

  var self = this;
  self.endPoint = '';



  //////////////////////////IntroJs//////////////////////////////////////

  rootScope.IntroOptions = IntroObject();

  //////////////////////////IntroJs//////////////////////////////////////



  $(".menu .main.button").mousedown(function () {
    $(this).parent().toggleClass("closed");
    if ($(this).parent().hasClass("closed")) {
      $(".main.button").text("منو");
    } else {
      $(".main.button").text("بستن");
    }
  });

  $(".notifications-nav").click(function (e) {
    $(".sp-notification-panel").addClass("active");
    $('body').append('<div id="sidenav-overlay"></div');
  });

  /// Show dropdown menu by clicking on it
  $('[data-toggle~="dropdown"]').on('click', function (e) {
    var ariaExpanded = $(this).attr("aria-expanded");
    closeAllDropDowns();
    if (ariaExpanded == "false") {
      dropDownMenu($(this), true);
    } else {
      dropDownMenu($(this), false);
    }

  });

  /// Closes all opened bootstrap drop down menus
  function closeAllDropDowns() {
    dropDownMenu($("[data-toggle~='dropdown']"), false);
  }

  $('body').on('click', function (e) {
    if ($(e.target).closest('[data-toggle~="dropdown"]').length == 0) {
      dropDownMenu($("[data-toggle~='dropdown']"), false);
    }
    if (($(e.target).closest('.sp-notification-panel').length == 0 && $(e.target).closest('.notifications-nav').length == 0) || $(e.target).closest('.sp-link').length != 0) {

      $(".sp-notification-panel").removeClass("active");
      $("#sidenav-overlay").remove()

    }
    if ($(e.target).closest('.sp-close-btn').length != 0) {
      $(".sp-notification-panel").removeClass("active");
      $("#sidenav-overlay").remove()
    }
    if ($(e.target).closest('.menu .main.button').length == 0) {
      if (!$('.menu .main.button').parent().hasClass("closed")) {
        $(".menu .main.button").parent().toggleClass("closed");
        $(".main.button").text("منو");
      }
    }
  });

  $(".fixed-action-btn").hover(function () {
    $(this).addClass('active');
    $(this).find('ul li .btn-floating').css({
      "transform": "scaleY(1) scaleX(1) translateY(0px) translateX(0px)",
      "opacity": "1"
    });
  }, function () {
    $(this).removeClass('active');
    $(this).find('ul li .btn-floating').css({
      "transform": "scaleY(0.4) scaleX(0.4) translateY(40px) translateX(0px)",
      "opacity": "0"
    });
  });

  $(".collapsible-header").click(function (e) {
    if ($(this).hasClass('active')) {
      $(this).removeClass("active");
      $(this).parent().removeClass("active");
      $(this).parent().find(".collapsible-body").hide();
    } else {
      $(".collapsible-header").removeClass("active");
      $(".collapsible-header").parent().removeClass("active");
      $(".collapsible-body").hide();
      $(this).parent().addClass("active");
      $(this).addClass("active");
      $(this).parent().find(".collapsible-body").show();
    }
  });

  //// Show and hide bootstrap dropdown menu by passing element and display state (true or false)
  function dropDownMenu(element, display) {
    if (display == false) {
      element.parent().removeClass("show");
      element.attr("aria-expanded", "false");
      element.parent().children(".dropdown-menu").removeClass("show");
    } else {
      element.parent().toggleClass("show");
      element.attr("aria-expanded", "true");
      element.parent().children(".dropdown-menu").toggleClass("show");
    }
  }

  self.goTinet = function () {
    location.href = `${location.origin}/${rootScope.userType}`
  }

  //breadcrumb
  self.goToBack = function () {
    let breadcrumbData = state.current.breadcrumbData;
    if (angular.isDefined(breadcrumbData)) {
      let parentState = breadcrumbData.parent;
      if (angular.isUndefined(parentState)) state.go("Dashboard.Index");
      else state.go(parentState);
    } else {
      state.go("Dashboard.Index");
    }
  };
}

module.exports = ngModule => {
  ngModule.controller('AppController', AppController);
};